import { render, staticRenderFns } from "./administratorList.vue?vue&type=template&id=8de9feca&scoped=true"
import script from "./administratorList.vue?vue&type=script&lang=js"
export * from "./administratorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de9feca",
  null
  
)

export default component.exports